export default (theme) => ({
  videoChat: {
    height: 'calc(100% - 200px)',
    display: 'flex',
    paddingTop: 10,
    margin: '0 20px',
    borderTop: `1px solid ${theme.palette.disabled.main}`,
    flexDirection: 'column',
    [theme.breakpoints.down('md')]: {
      height: 'calc(100% - 200px)',
    },
  },
  chatControls: {
    paddingLeft: 0,
    paddingRight: 0,
    paddingBottom: 20,
  },
  lineWrapper: {
    height: 'calc(100% - 20px)',
    padding: '10px 10px 10px 0',
    overflow: 'auto',
  },
  backButton: {
    position: 'absolute',
    top: 30,
    left: 40,
    padding: 15,
    background: 'none',
    border: 'none',
    [theme.breakpoints.down('md')]: {
      padding: '15px 0',
      top: 10,
      left: 20,
    },
  },
  backIcon: {
    width: 40,
    height: 40,
  },
  title: {
    fontSize: 22,
    fontWeight: 'bold',
    width: '70%',
  },
  thread: {
    paddingTop: 5,
  },
  caption: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
    textAlign: 'center',
  },
});
